import { GetterTree } from "vuex";
import { DeviceState, DeviceGetters, DeviceStorage, DeviceByDay } from "./interface";
import { DeviceGettersTypes } from "./types";
// import { store } from "@/store/store";

export const getters: GetterTree<DeviceState, DeviceState> & DeviceGetters = {
  [DeviceGettersTypes.DEVICE_ALL_ID]: (state: DeviceState): Array<string> => {
    /*  if (store.getters.GET_VIEW !== "ADMIN" && store.getters.GET_VIEW !== null) {
      return state.DeviceAllId.map((device_id) =>
        state.DeviceById[device_id].agence === store.getters.GET_VIEW ? device_id : undefined
      ).filter((a) => a !== undefined) as Array<string>;
    } */
    return state.DeviceAllId;
  },
  [DeviceGettersTypes.DEVICE_BY_ID]: (state: DeviceState): DeviceStorage => {
    return state.DeviceById;
  },
  [DeviceGettersTypes.GET_DEVICE_BY_DAY]: (state: DeviceState): Array<DeviceByDay> => {
    return state.DeviceByDay;
  }
};
